import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ManualAwardsService } from '../../../services/manual-awards.service';
import { AgGridAngular } from 'ag-grid-angular';

const columnDefs = [
  {
    headerName: "",
    field: "PreferredName",
    checkboxSelection: true,
    minWidth: 150,
    pinned: true
  },
  {
    headerName: "",
    field: "isVisible",
    pinned: true,
    hide: true
  }
];

type LoginData = {
  LoginName: string;
  PreferredName: string;
  Active: boolean;
  Email: string;
  ProfileID: number;
  LoginID: number;
  toAssign?: boolean;
};

type LoginDataAgGrid = LoginData & {
  isVisible: boolean;
};

type ModifiedData = {
  item?: {
    RuleID: number;
  };
  ResetToOriginal?: () => void;
}

@Component({
  selector: 'cv-give-award-popup',
  templateUrl: './give-award-popup.component.html',
  styleUrl: './give-award-popup.component.scss'
})
export class GiveAwardPopupComponent implements OnInit, OnChanges {

  @Input()
  awardToolVisible: boolean = false;

  @Input()
  empgrouptypes: any[] = [];

  @ViewChild('giveAwardPopupGrid') agGrid: AgGridAngular; // Angular grid reference to use API functions on

  awardToList: LoginData[] = [];

  @Input()
  manualAward: {
    RuleID?: number;
    AwardedCount?: number;
  } = {};

  @Input()
  loadHistory: boolean = false;
  @Output()
  onLoadHistory = new EventEmitter<void>();

  @Output()
  closeAwardPopup = new EventEmitter<void>();

  giveInProgress = false;

  showall = false;

  obj = {
    applyAt: {},
    GroupLevel: 0,
  }
  gridOptions: GridOptions<LoginDataAgGrid>;
  filterText: "";
  hiddenData: Array<{ data: LoginData }> = [];
  isDataLoading: boolean = true;
  selectedList: LoginData[] = [];
  isCheckedAll: boolean = false;
  rowData: Array<LoginDataAgGrid>[] = [];

  constructor(
    private cvApiService: CVApiService,
    private agGridHelperService: AgGridHelperService,
    private manualAwardsService: ManualAwardsService
  ) { }

  singleFilter(renderableRows) {
    const filterValue = this.filterText?.toLowerCase();
    // Iterate through rows
    renderableRows.forEach(function (row) {
      let match = false;
      // Iterate through columns (row items)
      for (let property in row.entity) {
        if (row.entity.hasOwnProperty(property) && property != "ID") {
          var value = row.entity[property];
          // Try to find a search value match
          if (value != null && value.toLowerCase().includes(filterValue))
            match = true;
        }
      }
      if (!match)
        row.visible = false;
    })

    return renderableRows;
  };

  clearTable() {
    if (!this.gridOptions || !this.agGrid?.api) return;
    this.agGrid.api.setGridOption('rowData', []);
  };

  async loadLogins(manualAward: { RuleID: number }) {
    this.isDataLoading = true;
    try {
      const data = await this.manualAwardsService.getLoginsForManualAward(manualAward.RuleID);
      this.isDataLoading = false;
      this.selectedList = (data as any).data;;
      this.isCheckedAll = false;
      this.clearTable(); // Clear old data out of the table
      const rows = [];
      for (var i = 0; i < this.selectedList.length; i++) {
        this.selectedList[i].toAssign = false;
        const newRow = {
          ID: i,
          LoginName: this.selectedList[i].LoginName,
          PreferredName: this.selectedList[i].PreferredName,
          Parent: '',
          singleSelect: '',
          isVisible: true
        };
        rows.push(newRow);
      }
      this.agGrid.api.setGridOption('rowData', rows);

      this.agGrid.api.deselectAll();
    } catch (error) {
      this.isDataLoading = false;
    }
  }

  onGridReadyAddEvent(event: GridReadyEvent<LoginDataAgGrid>) {
    this.agGrid?.api?.sizeColumnsToFit();
  }

  isItemsSelected() {
    if (this.selectedList == null || this.selectedList.length == 0) return false;
    return this.selectedList.some(selected => selected.toAssign);
  }

  updateOverlay() {
    if (this.agGrid?.api != null) {
      if (this.agGrid.api.getDisplayedRowCount() == 0) {
        this.agGrid.api.showNoRowsOverlay();
      } else {
        this.agGrid.api.hideOverlay();
      }
    }
  }

  //pass the new value to the grid for filtering
  updateGridFilter() {
    this.agGrid?.api?.onFilterChanged();
    this.updateOverlay();
  }

  addSelected() {
    const model = this.agGrid.api.getModel();

    for (let i = 0; i < this.selectedList.length; i++) {
      if (this.selectedList[i].toAssign == true) {
        //const row = this.agGrid.api.rowModel.rowsToDisplay[i];
        const row = this.agGrid.api.getModel().getRow(i);
        if (row) this.selectedList[row.id].toAssign = false;
        if (row && this.awardToList.indexOf(this.selectedList[row.id]) === -1) {
          this.awardToList.push(this.selectedList[row.id]);
          this.selectedList[row.id].toAssign = false;
          model.getRow(i).data.isVisible = false;
          model.getRow(i).setSelected(false);
        }
      }
    }

    if (this.selectedList.length && this.awardToList.length) this.isCheckedAll = false;
    this.filterText = "";
    this.updateGridFilter();
  }

  removeItem(index: number, item: any): void {
    const toRemove = this.awardToList[index];
    if (toRemove) {
      this.agGrid.api.forEachNode((node) => {
        if (node.data.LoginName === toRemove.LoginName) {
          node.data.isVisible = true;
          node.setSelected(false);
        }
      });

      this.awardToList[index].toAssign = false;
      this.awardToList.splice(index, 1);
    }

    this.filterText = "";
    this.updateGridFilter();
  };

  setAllChecked() {
    this.agGrid.api.forEachNode((node, i) => {
      const rowData = node.data;
      if (rowData.isVisible) {
        this.selectedList[i].toAssign = this.isCheckedAll;
      }
    });
    if (this.isCheckedAll) { //uncheck all boxes
      this.agGrid.api.selectAll();
    }
    else {  //check all boxes
      this.agGrid.api.deselectAll();
    }
  }

  //column check box change function to toggle the header column based on the column of check boxes
  updateAllChecked() {
    this.isCheckedAll = true;
  };

  closePopup() {
    this.closeAwardPopup.emit();
  }

  //empty search box
  clearSearch() {
    this.filterText = "";
    this.updateGridFilter();
    this.agGrid.api.onFilterChanged();
  };

  async giveAwards() {
    if (this.giveInProgress || this.awardToList == null || this.awardToList.length < 1 || !this.manualAward?.RuleID)
      return false;

    this.giveInProgress = true;
    try {
      let response = await this.manualAwardsService.giveOutAwards(this.manualAward,this.awardToList);

      this.giveInProgress = false;
      
      if(response)
        this.manualAward.AwardedCount+= response["TotalBadgesGiven"];

      if (this.loadHistory)
        this.onLoadHistory.emit();
      
      this.closePopup();
    } catch (error) {
      this.giveInProgress = false;
    }
  };



  ngOnChanges(changes: SimpleChanges): void {
    if (changes.manualAward && changes.manualAward.currentValue && changes.manualAward.currentValue.RuleID) {
      this.loadLogins(changes.manualAward.currentValue);
    }
    if (changes.awardToolVisible && changes.awardToolVisible.currentValue){
      // remove awardToList when the modal is not visible (when user click the close button)
      this.awardToList = [];
    }
  }

  ngOnInit(): void {
    this.setupGrid();
  }

  setupGrid() {
    this.gridOptions = this.agGridHelperService.createGridOptions({
      columnDefs,
      rowSelection: 'multiple',
      alwaysShowVerticalScroll: true,
      suppressRowClickSelection: true,
      suppressContextMenu: true,
      onGridReady: (e) => {
        e.api.sizeColumnsToFit();
        this.onGridReadyAddEvent(e);
      },
      onGridSizeChanged: function (e) {
        e.api.sizeColumnsToFit();
      },
      isExternalFilterPresent: () => true,
      doesExternalFilterPass: (node) => {
        const tmpFilter = this.filterText?.toUpperCase();
        const model = (this.agGrid.api.getModel() as unknown as { rowsToDisplay: Array<{ data: LoginDataAgGrid }> }).rowsToDisplay; // this is a bug of ag grid, wrong typedata
        this.hiddenData = model.filter(function (item) { return (!item.data.isVisible); });
        return ((node.data.PreferredName && node.data.PreferredName.toUpperCase().includes(tmpFilter)) && (node.data.isVisible)) || !this.filterText && node.data.isVisible;
      },
      localeText: { noRowsToShow: 'No Logins' },
      onSelectionChanged: () => {
        const model: any = this.agGrid.api.getModel();
        const processedRows = model.getRowCount();
        for (let i = 0; i < processedRows; i++) {
          this.selectedList[i].toAssign = model.rowsToDisplay[i].selected;
        }
      },
    });
  }

}
